// frontend/src/App.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Use centralized API URL from environment variable
const API_URL = process.env.REACT_APP_BACKEND_URL;

function NewsLetter() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [dailyMessage, setDailyMessage] = useState('Loading today\'s message...');

  // Fetch the daily message when the app loads
  useEffect(() => {
    axios.get(`${API_URL}/api/newsletter/message`)
      .then(response => {
        setDailyMessage(response.data.message);
      })
      .catch(error => {
        console.error('Error fetching daily message:', error);
        setDailyMessage('Could not load message.');
      });
  }, []);


  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setMessage(''); // Clear previous messages
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Please select a file first.');
      return;
    }

    const formData = new FormData();
    formData.append('emailFile', file);

    try {
      setMessage('Uploading...');
      const response = await axios.post(`${API_URL}/api/newsletter/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(`✅ Success: ${response.data}`);
    } catch (error) {
      setMessage(`❌ Error: ${error.response?.data || 'Could not upload file.'}`);
      console.error('Upload error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-8 px-2 relative">
      {/* Sample Excel Download Button */}
      <a
        href="/assets/img/newsLatterMail.xlsx"
        download
        className="absolute top-8 right-8 z-10 bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-lg shadow-md transition-all duration-200"
        style={{textDecoration: 'none'}}
      >
        Sample Excel for Test
      </a>
      <div className="w-full max-w-lg bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
        <h1 className="text-3xl font-bold text-indigo-700 mb-4 text-center">Onehub AI - Daily Email Automation</h1>
        <div className="mb-8 bg-indigo-50 border border-indigo-200 rounded-xl p-4 text-center">
          <h3 className="text-lg font-semibold text-indigo-600 mb-2">Today's Marketing Message</h3>
          <p className="text-gray-700">{dailyMessage}</p>
        </div>
        <div className="upload-section">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Upload Email List</h2>
          <p className="text-gray-600 mb-4">Upload an Excel (<span className="font-semibold text-indigo-600">.xlsx</span>, <span className="font-semibold text-indigo-600">.csv</span>) file with email addresses in any column.</p>
          <input
            type="file"
            onChange={handleFileChange}
            accept=".xlsx, .csv"
            className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-400 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 mb-4"
          />
          <button
            onClick={handleUpload}
            className={`w-full py-3 px-6 rounded-lg font-semibold text-white transition-all duration-200 shadow-md ${!file ? 'bg-indigo-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'}`}
            disabled={!file}
          >
            Upload and Add to Mailing List
          </button>
          {message && (
            <div className={`mt-6 text-center px-4 py-3 rounded-lg font-medium ${message.toLowerCase().includes('success') ? 'bg-green-50 text-green-700 border border-green-200' : message.toLowerCase().includes('error') ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-yellow-50 text-yellow-700 border border-yellow-200'}`}>
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewsLetter;